import Cookies from 'js-cookie';
import axios from 'axios';
import { Token } from 'aaro';
import { config } from 'Constants';
import { refreshGoogleToken } from 'services/api/user';

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        console.log('Interceptor triggered with error:', error.response?.status);
        const originalRequest = error.config;

        // Maksimum tekrar deneme sayısı
        originalRequest.retryCount = originalRequest.retryCount || 0;
        const MAX_RETRY_COUNT = 3;

        // 401 hatası ve tekrar deneme kontrolü
        if (error.response?.status === 401 && originalRequest.retryCount < MAX_RETRY_COUNT) {
            originalRequest.retryCount += 1;

            const user = JSON.parse(localStorage.getItem('user')) || {};
            console.log('Current user from localStorage:', user);

            // Google token yenileme
            if (user.googleAuth?.refreshToken) {
                const expiryDate = new Date(user.googleAuth.expiryDate);
                const now = new Date();
                console.log('Google Auth Status:', {
                    expiryDate,
                    now,
                    isExpired: now >= expiryDate,
                });

                if (now >= expiryDate) {
                    try {
                        console.log('Attempting to refresh Google token...');
                        const updatedUser = await refreshGoogleToken(user);
                        if (updatedUser) {
                            console.log('Token refresh successful, updating user...');
                            localStorage.setItem('user', JSON.stringify(updatedUser));

                            // Orijinal isteği yeni token ile tekrar dene
                            originalRequest.headers.Authorization = `Bearer ${updatedUser.googleAuth.accessToken}`;
                            return axios(originalRequest);
                        }
                        // Refresh başarısız olduğu zaman sessizce Aaro token'a geçelim
                        // Kullanıcıyı rahatsız etmeyelim, sonraki adımda diğer token'ları deneyelim
                        console.log('Google token refresh failed, trying alternate auth methods');
                    } catch (err) {
                        console.error('Google token refresh failed:', {
                            error: err,
                            response: err.response?.data,
                        });
                        // Google token yenileme başarısız olduğunda hemen kullanıcıyı rahatsız etmeyelim
                        // Sessizce Aaro token veya diğer metodlara geçelim
                    }
                }
            }

            // Aaro token yenileme kaldırıldı - artık onetime token kullanıyoruz
            // Eğer user'da aaroToken varsa ve request Aaro API'ye ise, original request'i bu token ile tekrar deneyelim
            if (
                user.aaroToken &&
                originalRequest.url &&
                (originalRequest.url.includes('aaro') || originalRequest.headers.Authorization?.includes('Bearer'))
            ) {
                console.log('Using stored Aaro token for retry...');
                originalRequest.headers.Authorization = `Bearer ${user.aaroToken}`;
                return axios(originalRequest);
            }

            // Genel token yenileme fallback
            if (user && user.token) {
                try {
                    const updatedUser = await refreshGoogleToken(user);
                    if (updatedUser && updatedUser !== user) {
                        localStorage.setItem('user', JSON.stringify(updatedUser));

                        // Orijinal isteği yeni token ile tekrar dene
                        originalRequest.headers.Authorization = `Bearer ${updatedUser.token}`;
                        return axios(originalRequest);
                    }
                } catch (err) {
                    console.error('Fallback token refresh failed:', err);
                    // Tüm token yenileme denemeleri başarısız olduğunda
                    // Kullanıcıyı logout etmek yerine, hata mesajı gösterelim
                    if (error.response?.data?.message) {
                        console.error('Authentication error:', error.response.data.message);
                    }
                }
            }
        }

        // Eğer tüm yenileme denemeleri başarısız olduysa ve hala 401 hatası alıyorsak
        if (error.response?.status === 401) {
            console.error('All token refresh attempts failed. User will be logged out.');
            // Kullanıcıyı logout etmeden önce son bir kontrol yapalım
            const currentUser = JSON.parse(localStorage.getItem('user'));
            if (!currentUser || !currentUser.token) {
                localStorage.removeItem('user');
                window.location.href = '/authentication/sign-in';
            }
        }

        return Promise.reject(error.response?.data || error);
    }
);

export default axios;
